import State from 'store/State';
import Services from 'store/Services';
import { buildLoggerForStore } from 'logging/writers/utils';
import { AnyActionType, AnyConfig } from 'widgets/WidgetRegistry';
import { updatingFromLayout } from 'layout/store/thunks';
import { ThunkDispatch } from 'store/store';
import { SetConfigAction } from './actions';
import { UIComponentConfiguration } from 'communication/types/uiConfiguration/UIConfiguration';
import { createLoadWidgetConfigurationAction } from 'widgets/store/configuration/actions';
import { extractWidgetConfigFromComponents } from 'widgets/store/configuration/helpers';

const log = buildLoggerForStore('updateWidgetConfigsFromUIConfig');

export const updateWidgetConfigsFromUIConfig =
    (components: { [key: string]: UIComponentConfiguration }) =>
    async (
        dispatch: ThunkDispatch<SetConfigAction<AnyActionType, AnyConfig>>,
        _getState: () => State,
        { loggingService }: Services
    ) => {
        log(loggingService, 'updateWidgetConfigsFromUIConfig', {
            components,
        });

        for (const config of extractWidgetConfigFromComponents(components)) {
            const {
                id: { widgetType, widgetKey },
                config: configState,
            } = config;

            const actionCreator =
                createLoadWidgetConfigurationAction(widgetType);
            const action = actionCreator(widgetKey, configState);
            dispatch(updatingFromLayout(action));
        }
    };
